import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../rtkQuery';
import { restApiFormData } from '../axios';
import { API_ENDPOINTS } from '../constants';

export const demandAttributesAPI = createApi({
    reducerPath: 'demandAttributesAPI',
    baseQuery: axiosBaseQuery(restApiFormData),
    endpoints: (builder) => ({
        viewMetaObjectDefinition: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.VIEW_META_OBJECT_DEFINITION,
                method: 'POST',
                data,
            }),
        }),
        listMetaObjectDefinitions: builder.mutation({
            query: () => ({
                url: API_ENDPOINTS.LIST_META_OBJECT_DEFINITIONS,
                method: 'POST',
            }),
        }),
        saveMetaObjectDefinition: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.SAVE_META_OBJECT_DEFINITION,
                method: 'POST',
                data,
            }),
        }),
        modifyMetaObjectDefinitionAction: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.MODIFY_META_OBJECT_DEFINITION_ACTION,
                method: 'POST',
                data,
            }),
        }),
        deleteMetaObjectDefinition: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.DELETE_META_OBJECT_DEFINITION,
                method: 'POST',
                data,
            }),
        }),
    }),
});

export const {
    useViewMetaObjectDefinitionMutation,
    useListMetaObjectDefinitionsMutation,
    useSaveMetaObjectDefinitionMutation,
    useModifyMetaObjectDefinitionActionMutation,
    useDeleteMetaObjectDefinitionMutation,
} = demandAttributesAPI;
